import { render, staticRenderFns } from "./RouletteBoard.vue?vue&type=template&id=ae0bf586&scoped=true&"
import script from "./RouletteBoard.vue?vue&type=script&lang=js&"
export * from "./RouletteBoard.vue?vue&type=script&lang=js&"
import style0 from "./RouletteBoard.vue?vue&type=style&index=0&id=ae0bf586&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0bf586",
  null
  
)

export default component.exports